/* eslint-disable react/prop-types */
import React from 'react';
import { StyledReadOnlyRenderComponent } from '../../styles';
import { StyledLabel } from './styles';
import { Switch } from '@cambridgeassessment/cambridge-ui';

interface Props {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  dataQaId?: string;
  readOnly?: boolean;
}

export const SwitchComponent: React.FC<Props> = ({ label, checked, onChange, dataQaId, readOnly = false }) => {
  return (
    <StyledReadOnlyRenderComponent data-qa-id={`read-only-wrapper-${readOnly}`} readOnly={readOnly}>
      <StyledLabel data-qa-id={`${dataQaId}-label`}>{label}</StyledLabel>
      <Switch
        dataQaId={`${dataQaId}-checked-${checked}`}
        checked={checked}
        onChange={onChange}
        disabled={readOnly}
        ariaLabel={label}
      />
    </StyledReadOnlyRenderComponent>
  );
};

export default SwitchComponent;
